<div class="log-view">
  <div class="overview-card">
    @if (aiUsageSummaryBadge; as usage) {
<bic-badge
     
      [title]="usage.models ? ('Modell: ' + usage.models) : null"
      class="overview-ai-usage-badge"
      type="info">
      @if (usage.models) {
<span class="overview-ai-usage-model">{{ usage.models }}</span>
}
      <fa-icon [icon]="faArrowUp"></fa-icon>&nbsp;{{ usage.inputText }}&nbsp;&nbsp;<fa-icon
      [icon]="faArrowDown"></fa-icon>&nbsp;{{ usage.outputText }}@if (usage.costText) {&nbsp;&nbsp;{{ usage.costText }}&nbsp;<fa-icon [icon]="faEuroSign"></fa-icon>}
    </bic-badge>
}
    <div class="overview-content">
      <div class="overview-grid">
        <div class="overview-column">
          <div class="overview-item">
            <span class="overview-label">Start</span>
            <span class="overview-value">{{ startText }}</span>
          </div>
          <div class="overview-item">
            <span class="overview-label">Organisation</span>
            <span class="overview-value">{{ progress.organisationName || '–' }}</span>
          </div>
        </div>
        <div class="overview-column">
          <div class="overview-item">
            <span class="overview-label">Dauer</span>
            <span class="overview-value">{{ elapsedFormatted || '–' }}</span>
          </div>
          <div class="overview-item">
            <span class="overview-label">Projekt</span>
            <span class="overview-value">{{ progress.projectName || '–' }}</span>
          </div>
        </div>
        <div class="overview-column">
          <div class="overview-item">
            <span class="overview-label">Ende</span>
            <span class="overview-value">{{ endText }}</span>
          </div>
          <div class="overview-item">
            <span class="overview-label">Prüfer*in</span>
            <span class="overview-value">{{ progress.checkerName || '–' }}</span>
          </div>
        </div>
        <div class="overview-column">
          <div class="overview-item">
            <span class="overview-label">Prüflauf Version</span>
            <span class="overview-value">{{ progress.myCheckVersion || '–' }}</span>
          </div>
          <div class="overview-item">
            <span class="overview-label with-icon">
              Prüf-ID
              <button (click)="copyCheckId()" class="copy-button" title="Prüf-ID kopieren" type="button">
                <fa-icon [icon]="faCopy"></fa-icon>
              </button>
            </span>
            <span class="overview-value">{{ progress.checkId || '–' }}</span>
          </div>
        </div>
      </div>
      <bic-badge [type]="overallStatusType">{{ overallStatusText }}</bic-badge>
    </div>
  </div>

  <div class="panels-grid">
    <div class="panel panel-rules">
      <div class="panel-header-rules">
        <div class="panel-header-rules-left">
          <fa-icon [icon]="faCircleCheck"></fa-icon>
          <h3>Ausgeführte Prüfregeln</h3>
        </div>
        <span class="panel-header-rules-count">{{ rulesSummaryText }}</span>
      </div>

      @if (rulesPanelGroups.length > 0) {
<div class="panel-list panel-list-rules">
        @for (group of rulesPanelGroups; track trackRuleset($index, group)) {
<div class="ruleset-group">
          <div class="ruleset-header">
            <div class="ruleset-header-main">
              <span class="ruleset-name truncate">{{ group.rulesetName }}</span>
              <span class="ruleset-count">{{ group.rulesCountText }}</span>
            </div>
            <div class="flex flex-row items-center gap-2">
              <bic-badge [type]="ruleSetBadgeType(group.rulesetType)">{{ ruleSetBadgeLabel(group.rulesetType) }}
              </bic-badge>
            </div>
          </div>

          <div class="rules-list">
            @for (rule of group.rules; track trackRule($index, rule)) {
<div class="rule-row">
              <div class="rule-row-main">
                <fa-icon [icon]="faCircleInfo"></fa-icon>
                <span class="rule-row-id truncate">{{ rule.ruleId }}</span>
              </div>
              <div class="rule-row-status">
                <bic-badge [type]="rule.statusType">{{ rule.statusText }}</bic-badge>
              </div>
              <div [tooltip]="rule.durationHint" class="rule-row-duration" tooltipDirection="top">
                <span class="rule-row-duration-value">{{ rule.durationText }}</span>
              </div>
            </div>
}
          </div>
        </div>
}
      </div>
} @else {

    <div class="empty-state">Keine Prüfregeln vorhanden.</div>
  
}
    </div>

    <div class="panel panel-files">
      <div class="panel-header-files">
        <div class="panel-header-files-left">
          <fa-icon [icon]="faFile"></fa-icon>
          <h3>Geprüfte Dateien</h3>
        </div>
        <span class="panel-header-files-count">{{ filesSummaryText }}</span>
      </div>

      @if (filesPanelRows.length > 0) {
<div class="panel-list panel-list-files">
        @for (file of filesPanelRows; track trackFile($index, file)) {
<div class="file-row">
          <div class="file-row-type">
            <bic-badge type="info">{{ file.fileType }}</bic-badge>
          </div>
          <div class="file-row-name truncate">{{ file.fileName }}</div>
          <div class="file-row-status">
            <bic-badge [type]="file.statusType">{{ file.statusText }}</bic-badge>
          </div>
          <div [tooltip]="file.durationHint" class="file-row-duration" tooltipDirection="top">
            <span class="file-row-duration-value">{{ file.durationText }}</span>
          </div>
        </div>
}
      </div>
} @else {

    <div class="empty-state">Keine Dateien vorhanden.</div>
  
}
    </div>

    <div class="panel panel-log">
      <div class="panel-header-log">
        <div class="panel-header-log-left">
          <fa-icon [icon]="faSquareTerminal"></fa-icon>
          <h3>Ereignisprotokoll</h3>
        </div>
        <div class="panel-header-log-right">
          <span class="panel-header-log-count">{{ filteredLogCount }} Einträge</span>
          <app-bic-filter (filtersChange)="onEventFiltersChange($event)"
                          [filtersConfig]="eventFilterConfig"></app-bic-filter>
        </div>
      </div>

      @if (logRows.length > 0) {
<cdk-virtual-scroll-viewport
                                   [itemSize]="32"
                                   class="panel-list panel-list-log">
        <!--
          Feste Zeilenhöhe: [itemSize] und die tatsächliche Höhe müssen übereinstimmen, sonst rechnet
          der Viewport falsch. Deshalb wird der Detailblock NICHT in die Zeile gerendert, sondern
          unterhalb der Liste – und es ist immer nur einer offen.
        -->
        <div *cdkVirtualFor="let row of logRows; trackBy: trackLogRow" class="event-log-item">
          <div (click)="toggleRowDetails(row)"
               [class.cursor-pointer]="row.hasDetails"
               class="event-log-row group items-start">
            <div [tooltip]="row.absoluteTimestamp" class="event-log-time" tooltipDirection="top">
              {{ row.relativeTimestamp }}
            </div>
            <div class="event-log-level w-[72px] basis-[72px] shrink-0">
              <bic-badge
                [type]="row.levelType"
                class="block w-full [&>div]:w-full [&>div]:px-2 [&>div]:justify-center [&>div>span:first-child]:hidden [&>div>span:last-child]:hidden [&>div>span:nth-child(2)]:mx-auto [&>div>span:nth-child(2)]:text-center [&>div>span:nth-child(2)]:!overflow-visible [&>div>span:nth-child(2)]:!whitespace-nowrap [&>div>span:nth-child(2)]:!text-clip">
                {{ row.levelLabel }}
              </bic-badge>
            </div>
            <div class="event-log-message">
              <div
                [class.cursor-pointer]="row.hasDetails"
                [title]="row.message"
                class="event-log-message-main line-clamp-1 break-words group-hover:line-clamp-none">
                {{ row.message }}
              </div>
            </div>
            @if (row.hasDetails) {
<div class="event-log-expand-toggle w-4 shrink-0 text-gray-400">
              <fa-icon [icon]="isRowExpanded(row) ? faChevronDown : faChevronRight"></fa-icon>
            </div>
}
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
} @else {

    <div class="empty-state">Keine Ereignisse vorhanden.</div>
  
}

      <!-- Details des aufgeklappten Eintrags: nachgeladen und auf Anzeigelänge gekürzt. -->
      @if (detailIsLoading || detailErrorMessage || visibleDetailRows.length > 0) {
<div
           class="event-log-details">
        @if (detailIsLoading) {
<div class="event-log-details-row">
          <span class="event-log-details-key">Details werden geladen …</span>
        </div>
}
        @if (detailErrorMessage) {
<div class="event-log-details-row">
          <span class="event-log-details-key">{{ detailErrorMessage }}</span>
        </div>
}
        @for (entry of visibleDetailRows; track trackDetailRow($index, entry)) {
<div class="event-log-details-row">
          <span class="event-log-details-key">{{ entry.key }}:</span>
          <span class="event-log-details-value">{{ entry.value }}</span>
        </div>
}
      </div>
}
    </div>
  </div>

  
  
  
</div>
